import { Redirect, useLocalSearchParams } from "expo-router";

export default function HomeScreen() {
  const { sessionExpired } = useLocalSearchParams<{
    sessionExpired?: string | string[];
  }>();
  const sessionExpiredParam = Array.isArray(sessionExpired)
    ? sessionExpired[0]
    : sessionExpired;

  return (
    <Redirect
      href={
        sessionExpiredParam
          ? {
              pathname: "/de",
              params: { sessionExpired: sessionExpiredParam },
            }
          : "/de"
      }
    />
  );
}
